import { BUILD_COMPLETE_TRANSFORMATION_SQL_OPERATION } from 'app/store/__generated__/operations';
import { GET_TRANSFORM_SQL } from './types.js';

export const doGetTransformSql = (uuid) => ({
    type: GET_TRANSFORM_SQL,
    api: { ...BUILD_COMPLETE_TRANSFORMATION_SQL_OPERATION, sync: true },
    params: { uuid },
    meta: { uuid }
});
